// MARK: React
import * as React from "react";
import { observer, inject } from "mobx-react";
import "./style.scss";

// MARK: Components
import TextField from "../../../../components/TextField";
import ImageCase from "../../../../components/ImageCase";
import Button from "../../../../components/Button";
import Divider from "../../../../components/Divider";
import BedroomComfortSection from "./BedroomComfortSection";

// MARK: Stores
import { routerStore } from "../../../../stores/_rootStore";
import BedroomStore from "../../../../stores/BedroomStore";
import UIStore from "../../../../stores/_UIStore";

// MARK: Resources
import strings from "../../../../resources/strings";
import { match as Match } from "react-router";

interface IProps {
	bedroomStore: BedroomStore;
	uiStore: UIStore;
	match: Match<{ bedroomId?: string }>;
}

@inject("bedroomStore", "uiStore")
@observer
export default class BedroomCreateOrEdit extends React.Component<IProps> {
	public componentWillMount = async () => {
		const bedroomId = this.props.match.params.bedroomId;
		if (bedroomId) {
			await this.props.bedroomStore.getBedroom(bedroomId);
		}
	};

	public render() {
		const { bedroomStore } = this.props;
		return (
			<div className="bedroomCreateOrEdit">
				{!bedroomStore.loading && (
					< div className="bedroomCreateOrEditWrapper">
						<h1 className="bedroomCreateOrEditTitle">{bedroomStore.selectedBedroom ? strings.bedrooms.createOrEdit.title.edit : strings.bedrooms.createOrEdit.title.new}</h1>
						<div className="bedroomFormContainer">
							<h2>{strings.bedrooms.createOrEdit.sections.data}</h2>
							<TextField
								label={strings.bedrooms.createOrEdit.nick}
								name="nick"
								value={bedroomStore.nick}
								onChange={bedroomStore.handleValueChange}
								disabled={bedroomStore.loading}
								required={true}
							/>
							<TextField
								label={strings.bedrooms.createOrEdit.name}
								name="name"
								value={bedroomStore.name}
								onChange={bedroomStore.handleValueChange}
								disabled={bedroomStore.loading}
								required={true}
							/>
							<TextField
								label={strings.bedrooms.createOrEdit.description}
								name="description"
								multiline={true}
								value={bedroomStore.description}
								onChange={bedroomStore.handleValueChange}
								disabled={bedroomStore.loading}
							/>
							<TextField
								label={strings.bedrooms.createOrEdit.externalUrl}
								name="url"
								value={bedroomStore.url}
								onChange={bedroomStore.handleValueChange}
								disabled={bedroomStore.loading}
							/>
							<TextField
								label={strings.bedrooms.createOrEdit.positionBedroom}
								name="order"
								type="number"
								inputProps={{ min: "0" }}
								value={bedroomStore.order}
								onChange={bedroomStore.handleValueChange}
								disabled={bedroomStore.loading}
								required={false}
							/>
						</div>
						<BedroomComfortSection bedroomStore={bedroomStore} />
						<Divider className="divider" />
						<ImageCase
							title={strings.bedrooms.createOrEdit.imagesTitle}
							onAddItem={bedroomStore.imageService.selectImages}
							onRemoveItem={bedroomStore.imageService.removeImage}
							onReloadItem={bedroomStore.imageService.reloadImage}
							imageUploaders={bedroomStore.imageService.imageUploaders}
						/>
						<div className="buttonsContainer">
							<Button
								onClick={() => bedroomStore.createOrEditBedroom()}
								style={{ backgroundColor: "#0081B0", color: "white" }}
							>
								{strings.bedrooms.createOrEdit.buttons.save}
							</Button>
							<Button
								onClick={() => routerStore.push("/dashboard/bedrooms")}
							>
								{strings.bedrooms.createOrEdit.buttons.back}
							</Button>
						</div>
					</div>
				)
				}
			</div>
		);
	}
}
